import {
    Dialog, DialogContent, DialogHeader, DialogTitle
} from 'shared/components/ui/dialog';
import {
    cn
} from 'shared/lib/utils';
import {
    ChevronDown
} from 'lucide-react';
import {
    forwardRef, useImperativeHandle, useState
} from 'react';
import {
    AnimatePresence, motion
} from 'framer-motion';

export default forwardRef(function ActionButton({
    disabled = false, icon, label, action = 'trigger', dialogTitle = 'Dialog', onClick = () => { }, children
}, ref) {
    const [toggleState, setToggleState] = useState(false);
    const [isDisabled,] = useState(disabled);
    const [dialogOpen, setDialogOpen] = useState(false);
    const ICON_SIZE = 17;

    const handleClick = () => {
        switch (action) {
            case 'trigger':
                break;
            case 'toggle':
                setToggleState((prev) => !prev);
                break;
            case 'openDialog':
                setDialogOpen(true);
                break;
            default:
        }
        onClick();
    };

    const handleAppearance = () => {
        let className = '';
        if (toggleState || dialogOpen) {
            className += ' bg-foreground text-background border-foreground';
        } else {
            className += ' bg-background text-foreground border-border hover:bg-muted';
        }
        return className;
    };

    useImperativeHandle(ref, () => ({
        toggleState,
        setToggleState,
    }), [toggleState]);

    return (
        <div className="mb-2">
            <button
                disabled={isDisabled}
                data-toggled={toggleState}
                onClick={() => handleClick()}
                className={cn('flex text-sm font-medium items-center justify-between w-full rounded-lg p-3 transition-all duration-200 border', handleAppearance())}
            >
                <div className="flex gap-3 items-center">
                    <div className={cn('p-1.5 rounded', toggleState ? 'bg-background text-foreground' : 'bg-muted')}>
                        {icon}
                    </div>
                    <p>{label}</p>
                </div>
                {action === 'toggle' && (
                    <ChevronDown
                        size={ICON_SIZE}
                        className={cn('transition-transform duration-200', toggleState ? 'rotate-180' : '')}
                    />
                )}
            </button>

            <AnimatePresence initial={false}>
                {toggleState && action === 'toggle' && children && (
                    <motion.div
                        initial={{
                            height: 0,
                            opacity: 0
                        }}
                        animate={{
                            height: 'auto',
                            opacity: 1
                        }}
                        exit={{
                            height: 0,
                            opacity: 0
                        }}
                        transition={{
                            duration: 0.2,
                            ease: 'easeInOut'
                        }}
                        className="mt-1 bg-background border border-border rounded-lg p-3"
                    >
                        {children}
                    </motion.div>
                )}
            </AnimatePresence>

            <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
                <DialogContent className="flex flex-col gap-0 min-w-[80vw] min-h-[90vh] max-w-[95vw] rounded-lg border border-border bg-background">
                    <DialogHeader className="h-fit pb-3 border-b border-border">
                        <DialogTitle className="text-lg font-medium text-foreground">{dialogTitle}</DialogTitle>
                    </DialogHeader>
                    <div className="flex-grow h-0 pt-3">
                        {children}
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
});